import * as React from "react";
import { cn } from "../../lib/utils";
import { Slot } from "@radix-ui/react-slot";

const Button = React.forwardRef(
  ({ className, variant = "default", size = "default", asChild = false, onClick, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";

    return (
      <Comp
        className={cn(
          "ui-btn inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl font-sans font-semibold normal-case tracking-[-0.01em] transition-all duration-200 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50",
          variant === "default" &&
            "ui-btn-primary text-primary-foreground hover:brightness-110",
          variant === "destructive" &&
            "bg-destructive text-destructive-foreground hover:opacity-90",
          variant === "outline" &&
            "border border-border-2 bg-transparent text-foreground hover:bg-foreground/5 hover:border-border-2",
          variant === "secondary" &&
            "bg-surface-2 text-foreground border border-border hover:border-border-2",
          variant === "ghost" &&
            "text-muted-foreground hover:bg-surface-2 hover:text-foreground",
          variant === "link" &&
            "text-primary underline-offset-4 hover:underline normal-case tracking-normal",
          size === "default" && "h-10 px-4 text-sm",
          size === "sm" && "h-8 px-3 text-[13px] rounded-lg",
          size === "lg" && "h-12 px-6 text-[15px]",
          size === "icon" && "h-9 w-9 p-0",
          className
        )}
        ref={ref}
        onClick={onClick}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button };
